/**
 * Task status color mappings
 */
export const getStatusColor = (status) => {
    const colorMap = {
        running: 'bg-admin_success/20 text-admin_success',
        completed: 'bg-admin_info/20 text-admin_info',
        error: 'bg-admin_error/20 text-admin_error',
        stopped: 'bg-admin_warning/20 text-admin_warning'
    };
    return colorMap[status] || 'bg-admin_neutral_1 text-admin_text_secondary';
};

/**
 * Status filter options for DataTable
 */
export const STATUS_FILTER_OPTIONS = [
    { value: "running", name: "Running" },
    { value: "completed", name: "Completed" },
    { value: "error", name: "Error" },
    { value: "stopped", name: "Stopped" }
];

/**
 * Suspended state filter options
 */
export const SUSPENDED_FILTER_OPTIONS = [
    { value: "active", name: "Active" },
    { value: "suspended", name: "Suspended" }
];
